import { render, staticRenderFns } from "./IFrameContent.vue?vue&type=template&id=2e49e431&scoped=true&"
import script from "./IFrameContent.vue?vue&type=script&lang=js&"
export * from "./IFrameContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e49e431",
  null
  
)

export default component.exports